import logo from "@/assets/ze-padoca-icon.svg";
import { cn } from "@/lib/utils";

/**
 * O ícone da marca, o mesmo arquivo usado pelos dois aplicativos
 * (`assets/icons/svg/ze-padoca-icon.svg`).
 *
 * Ele já traz o círculo na cor da marca e o pão em branco, então não precisa de
 * fundo nem de recorte aqui: a arte é a forma. Antes disso, o painel desenhava
 * um quadrado com as letras "ZP", que era reserva de quando o SVG não estava
 * no repositório.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src={logo}
      alt=""
      aria-hidden
      className={cn("shrink-0 select-none", className)}
    />
  );
}
